import { ReactComponent as LogoYouse } from "assets/svgs/logo-youse-for-card.svg";
import { ReactComponent as LogoCnp } from "assets/svgs/logo-cnp-reverse-for-card.svg";
import { ReactComponent as LogoCaixa } from "assets/svgs/logo-caixa-seguradora-for-card.svg";
import env from "config/envs";

export const CnpHoldingCardItems = [
  {
    img: <LogoCaixa />,
    paragraph:
      "Surgiu a partir da união entre duas gigantes: a CNP Assurances e a Caixa. Juntas, fazem a gestão dos seguros Habitacional e Residencial (comercializados até 2021) e do seguro Empresarial.",
    link: "https://www.caixaseguradora.com.br",
  },
  {
    img: <LogoYouse width="180px" height="75px" />,
    paragraph:
      "100% digital, a Youse revolucionou o jeito de vender seguro no País. Inovadora e com 50% da fatia do mercado, tornou-se um case de sucesso quando o assunto é experiência do cliente.",
    link: "https://www.youse.com.br",
  },
  {
    img: <LogoCnp />,
    paragraph:
      "Tem o objetivo de consolidar nossos investimentos socioambientais, alinhados com as diretrizes do Pacto Global da Organização das Nações Unidas (ONU), do qual somos signatários desde 2008.",
    link: env.HOST_INSTITUTE,
  },
];
